import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { end } from '@popperjs/core';
import { padStart } from 'lodash';
import { TimeInterval } from 'rxjs/internal/operators/timeInterval';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-rfs-extend-lock-dialog',
  templateUrl: './rfs-extend-lock-dialog.component.html',
  styleUrls: ['./rfs-extend-lock-dialog.component.scss']
})
export class RfsExtendLockDialogComponent implements OnDestroy {
  timeString: string = `${environment.rfsSessionExtensionWindowInMinutes}:00`
  timerInterval: ReturnType<typeof setInterval>;
  startTime: Date = new Date()
  endTime: Date
  constructor(private matDialogRef: MatDialogRef<RfsExtendLockDialogComponent>) {
    this.endTime = new Date()
    this.endTime.setMinutes(this.startTime.getMinutes() + environment.rfsSessionExtensionWindowInMinutes)
    this.timeString = this.convertTimeDiffToDateString(this.endTime);
    this.timerInterval = setInterval(() => {
      this.timeString = this.convertTimeDiffToDateString(this.endTime);
    }, 1000)
  }
  convertTimeDiffToDateString(endTime: Date) {
    let distance = endTime.getTime() - new Date().getTime()
    let minDisplay = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let secDisplay = Math.floor((distance % (1000 * 60)) / 1000);
    let timeString = `${minDisplay > 0 ? padStart(minDisplay.toString(), 2, '0') : '00'}: ${secDisplay > 0 ? padStart(secDisplay.toString(), 2, '0') : '00'}`
    return timeString
  }
  ngOnDestroy(): void {
    clearInterval(this.timerInterval)
  }
  onNoClick() {
    this.matDialogRef.close(false)
  }
  onYesClick() {
    this.matDialogRef.close(true)
  }
}
